import { useContext } from 'react';
import { useSubscription } from '@apollo/client';

import AuthContext from 'app/src/contexts/AuthContext';

import {
  CONVERSATION, CONVERSATION_UPDATED, CONVERSATION_PENDING
} from './queries';

const useSubscriptions = ({ id }) => {
  const { apolloClient: client } = useContext(AuthContext);

  useSubscription(CONVERSATION_UPDATED, {
    variables: { conversationId: id },
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (!data || !data.conversationUpdated) return;

      client.writeQuery({
        query: CONVERSATION,
        variables: { id },
        data: { conversation: data.conversationUpdated.conversation },
      });
    }
  })

  useSubscription(CONVERSATION_PENDING, {
    variables: {},
    onSubscriptionData: ({ subscriptionData: { data } }) => {
      if (!data || !data.conversationPending) return;

      client.writeQuery({
        query: CONVERSATION,
        variables: { },
        data: { conversation: data.conversationPending.conversation },
      });
    }
  })
}

export default useSubscriptions;